import { useEffect, useState } from "react"
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Badge,
    useToast,
    Text,
} from "@chakra-ui/react"
import { useDispatch, useSelector } from "react-redux"

import { fetchEmployerDataAsync, selectEmployerData, selectPagination, verifyEmployerAsync } from "../../EmployerData/EmployerDataSlice"

const EmployerList = () => {
    const dispatch = useDispatch()
    const empolyerdata = useSelector(selectEmployerData)
    const pagination = useSelector(selectPagination)
    const toast = useToast()

    const [currentPage, setCurrentPage] = useState(1)
    const [isLoading, setIsLoading] = useState(true)
    const [selectedCandidate, setSelectedCandidate] = useState(null)
    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() => {
        dispatch(fetchEmployerDataAsync(currentPage))
            .then(() => setIsLoading(false))
            .catch(() => setIsLoading(false))
    }, [dispatch, currentPage])

    const handlePrevPage = () => {
        if (pagination.current_page > 1) {
            setCurrentPage((prev) => prev - 1)
        }
    }

    const handleNextPage = () => {
        if (pagination.current_page < pagination.last_page) {
            setCurrentPage((prev) => prev + 1)
        }
    }

    const handleVerifyClick = (candidate) => {
        setSelectedCandidate(candidate)
        onOpen()
    }

    const handleVerifyConfirm = () => {
        if (selectedCandidate) {
            dispatch(verifyEmployerAsync({ uuid: selectedCandidate.uuid, verifyData: { status: true } }))
                .unwrap()
                .then(() => {
                    onClose()
                    toast({
                        title: "Candidate Verified",
                        description: "The candidate has been successfully verified.",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    })
                    dispatch(fetchEmployerDataAsync(currentPage))
                })
                .catch((error) => {
                    console.error("Verification failed:", error)
                    toast({
                        title: "Verification Failed",
                        description: "There was an error verifying the candidate.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    })
                    onClose()
                })
        }
    }
    const handleNotVerify = () => {
        if (selectedCandidate) {
            dispatch(verifyEmployerAsync({ uuid: selectedCandidate.uuid, verifyData: { status: false } }))
                .unwrap()
                .then(() => {
                    onClose()
                    toast({
                        title: "Candidate Verified",
                        description: "The candidate has not verified.",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    })
                    dispatch(fetchEmployerDataAsync(currentPage))
                })
                .catch((error) => {
                    console.error("Verification failed:", error)
                    toast({
                        title: "Verification Failed",
                        description: "There was an error verifying the candidate.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    })
                    onClose()
                })
        }
    }

    return (
        <div className="contentAdmin bg-adminbg rounded p-4">
            <div className="bg-white my-5 rounded-md" style={{ fontFamily: "Inter, sans-serif" }}>
                <div className="flex justify-between">
                    <p className="text-xl text-black font-semibold px-3 py-7">Employer List</p>
                </div>
                <TableContainer>
                    <Table size="sm">
                        <Thead className="bg-gray-200">
                            <Tr>
                                <Th>ID</Th>
                                <Th>Name</Th>
                                <Th>Email</Th>
                                <Th>Phone</Th>
                                <Th>Status</Th>
                                <Th>Verified</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {isLoading ? (
                                <Tr>
                                    <Td colSpan="7" className="text-center py-4">
                                        Loading...
                                    </Td>
                                </Tr>
                            ) : empolyerdata && empolyerdata.length > 0 ? (
                                empolyerdata.map((data, index) => (
                                    <Tr key={data.uuid}>
                                        <Td>{index + 1}</Td>
                                        <Td>{data.name}</Td>
                                        <Td textColor={"green"}>{data.email}</Td>
                                        <Td>
                                            <div className="text-sm opacity-90 text-blue-700">{data.phone}</div>
                                        </Td>
                                        <Td textColor={"green"} className="flex gap-2">
                                            <div className="w-2 mt-1 h-2 rounded-full bg-green-400"></div>
                                            Active
                                        </Td>
                                        <Td>
                                            <Badge colorScheme={data.employer_verified ? "green" : "red"}>
                                                {data.employer_verified ? "Verified" : "Not Verified"}
                                            </Badge>
                                        </Td>
                                        <Td>
                                            {!data.is_verified && (
                                                <Button size="sm" colorScheme="blue" onClick={() => handleVerifyClick(data)}>
                                                    Verify
                                                </Button>
                                            )}
                                        </Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan="7" className="text-center py-4">
                                        No data available
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <div className="flex justify-center my-2">
                <Button
                    onClick={handlePrevPage}
                    isDisabled={pagination.current_page === 1}
                    colorScheme="blue"
                    mx={2}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                    Previous
                </Button>
                <span className="px-4 py-2 text-lg font-medium">
                    Page {pagination.current_page} of {pagination.last_page}
                </span>
                <Button
                    onClick={handleNextPage}
                    isDisabled={pagination.current_page === pagination.last_page}
                    colorScheme="blue"
                    mx={2}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                    Next
                </Button>
            </div>

            {/* Verification Modal */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                    <ModalHeader
                        fontSize="lg" fontWeight="bold" textAlign="center"
                    >Verify Candidate</ModalHeader>

                    <ModalCloseButton />

                    <ModalBody>


                        <Text fontSize="md" textAlign="center">
                            Do you want to verify this candidate{" "}
                            <Text as="span" fontWeight="semibold" color="red.500">
                                "{selectedCandidate?.name}"
                            </Text>
                            ?
                        </Text>
                    </ModalBody>
                    <ModalFooter display="flex" gap="2" justifyContent="center">
                        <Button colorScheme="blue" w="40" onClick={handleVerifyConfirm}>
                            Yes
                        </Button>
                        <Button variant="outline" colorScheme="blue" w="40" onClick={handleNotVerify}>
                            No
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </div>
    )
}

export default EmployerList
